import { createContext } from "react";
import type { MentionResolution } from "@cometchat-ai/core";

/**
 * Map of `#kind/slug` token → live resolution, provided by PromptMentionEditor
 * so each MentionChip NodeView can colour itself without prop-drilling through
 * ProseMirror. Keyed with tool folded into skill (shared namespace).
 */
export const MentionResolutionsContext = createContext<Map<string, MentionResolution>>(new Map());
